import {useState,useEffect} from "react";
import styles from "./ImgLoad.module.css"
import Spin from "../../components/UI/Spin/Spin";
function Img (url_server,class_name){
    const [url, setUrl] = useState('');
    fetch(url_server)
        .then(response => response.blob())
        .then((image) => {
            setUrl(URL.createObjectURL(image));
        });

    if (!url) {
        return <div className={styles.skeleton}><Spin/></div>;
    }

    return <img className={class_name} src = {url}/>;
}
export default Img